(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["button"] && !Shopify.designMode) return;
  try {
    window.selectVariant = function (pill, productId, sectionId) {
    // Don't do anything if the variant is unavailable
    if (pill.classList.contains('unavailable')) {
      return;
    }

    // Remove active class from all pills
    const pills = pill.parentElement.querySelectorAll('.variant-pill');
    pills.forEach((p) => p.classList.remove('active'));

    // Add active class to clicked pill
    pill.classList.add('active');

    // Update the hidden select element
    const select = document.getElementById('ProductSelect-' + productId + '-' + sectionId);
    select.value = pill.dataset.variantId;

    // Update the add to cart button
    const form = select.closest('form');
    const addButton = form.querySelector('.js-add-to-cart');
    const priceElement = form.querySelector('.js-product-upsell-price');
    const compareAtPriceElement = form.querySelector('.js-product-upsell-compare-at-price');

    // Update price display
    if (priceElement) {
      priceElement.textContent = pill.dataset.price;
    }

    // Update compare at price
    if (compareAtPriceElement && pill.dataset.compareAtPrice) {
      const compareAtPrice = parseFloat(pill.dataset.compareAtPrice.replace(/[^0-9.-]+/g, ''));
      const price = parseFloat(pill.dataset.price.replace(/[^0-9.-]+/g, ''));

      if (compareAtPrice > price) {
        compareAtPriceElement.textContent = pill.dataset.compareAtPrice;
        compareAtPriceElement.classList.remove('hidden');
      } else {
        compareAtPriceElement.classList.add('hidden');
      }
    }

    // Update button availability
    if (pill.dataset.available === 'true') {
      addButton.disabled = false;
      addButton.removeAttribute('aria-disabled');
      addButton.querySelector('span:first-child').classList.remove('hidden');
      addButton.querySelector('span:last-child').classList.add('hidden');
    } else {
      addButton.disabled = true;
      addButton.setAttribute('aria-disabled', 'true');
      addButton.querySelector('span:first-child').classList.add('hidden');
      addButton.querySelector('span:last-child').classList.remove('hidden');
    }

    // Check for parent .product-card and swap image if variant has featured image
    const currentBlock = pill.closest('[id^="shopify-block-"]');
    if (currentBlock) {
      const productCard = currentBlock.closest('.product-card');
      if (productCard) {
        const imageWrapper = productCard.querySelector('.shopify-block-img-wrapper img');
        if (imageWrapper) {
          // Get variant image overrides from JSON data
          const productCardData = productCard.querySelector('.product-card-data');
          let variantImageOverrides = null;

          if (productCardData) {
            try {
              const jsonData = JSON.parse(productCardData.textContent);
              variantImageOverrides = jsonData.variant_image_overrides;
            } catch (e) {
              console.warn('Failed to parse product card data:', e);
            }
          }

          // Check for variant image override from parent
          const variantIndex = Array.from(pills).indexOf(pill);
          const overrideImage = variantImageOverrides ? variantImageOverrides[variantIndex + 1] : null;

          if (overrideImage) {
            imageWrapper.src = overrideImage;
            if (imageWrapper.srcset) {
              imageWrapper.srcset = overrideImage;
            }
          } else if (pill.dataset.featuredImage && pill.dataset.featuredImage !== '') {
            imageWrapper.src = pill.dataset.featuredImage;
            if (imageWrapper.srcset) {
              imageWrapper.srcset = pill.dataset.featuredImage;
            }
          }
        }
      }
    }
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    (function () {
    function normalizeUsPhone(value) {
      if (window.DieuxAttentiveSms && typeof window.DieuxAttentiveSms.normalizePhone === 'function') {
        return window.DieuxAttentiveSms.normalizePhone(value);
      }

      var phoneValue = String(value || '').trim();
      if (!phoneValue || /[^0-9\s()+.-]/.test(phoneValue)) return '';

      var digits = phoneValue.replace(/\D/g, '');
      if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
      return digits.length === 10 ? '+1' + digits : '';
    }

    function initContactForms(root) {
      var scope = root || document;
      var wrappers = scope.querySelectorAll('.js-dcf-wrapper');

      wrappers.forEach(function (wrapper) {
        if (wrapper.dataset.dcfInitialized === 'true') return;
        wrapper.dataset.dcfInitialized = 'true';

        var form = wrapper.querySelector('.js-dcf-form');
        var fields = wrapper.querySelector('.js-dcf-fields');
        var success = wrapper.querySelector('.js-dcf-success');
        var error = wrapper.querySelector('.js-dcf-error');
        var submit = wrapper.querySelector('.js-dcf-submit');
        var conditionalFields = wrapper.querySelectorAll('.js-dcf-conditional-field');

        if (!form || !fields || !success || !error || !submit) return;

        if (!success.dataset.defaultSuccessHtml) {
          success.dataset.defaultSuccessHtml = success.innerHTML;
        }

        function escapeHtml(value) {
          return String(value || '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
        }

        function replaceSuccessTokens() {
          var emailInput = form.querySelector('[name="contact[email]"]');
          var email = emailInput ? emailInput.value : '';
          var template = success.dataset.defaultSuccessHtml || success.innerHTML;
          success.innerHTML = template
            .replace(/\{\{\s*customer_email\s*\}\}/g, escapeHtml(email))
            .replace(/\[\[\s*customer_email\s*\]\]/g, escapeHtml(email));
        }

        function restoreSubmitState(defaultText) {
          submit.disabled = false;
          submit.textContent = defaultText;
          form.removeAttribute('aria-busy');
        }

        function runAfterPaint(callback) {
          if (typeof window.requestAnimationFrame !== 'function') {
            window.setTimeout(callback, 0);
            return;
          }

          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(callback);
          });
        }

        function waitForSuccessMessagePaint() {
          return new Promise(function (resolve) {
            var pendingImages = Array.prototype.slice
              .call(success.querySelectorAll('img'))
              .filter(function (image) {
                return !image.complete;
              });

            function finish() {
              runAfterPaint(resolve);
            }

            if (!pendingImages.length) {
              finish();
              return;
            }

            var remaining = pendingImages.length;
            var timeout = window.setTimeout(function () {
              remaining = 0;
              finish();
            }, 1500);

            function handleImageReady() {
              if (remaining <= 0) return;

              remaining -= 1;

              if (remaining === 0) {
                window.clearTimeout(timeout);
                finish();
              }
            }

            pendingImages.forEach(function (image) {
              image.addEventListener('load', handleImageReady, { once: true });
              image.addEventListener('error', handleImageReady, { once: true });

              if (image.complete) {
                handleImageReady();
              }
            });
          });
        }

        function isAjaxSubmissionSupported() {
          return (
            typeof window.fetch === 'function' &&
            typeof window.FormData === 'function' &&
            typeof window.DOMParser === 'function'
          );
        }

        function cleanContactPostedQuery() {
          if (!window.URL || !window.history || typeof window.history.replaceState !== 'function') return;

          var url = new URL(window.location.href);

          if (!url.searchParams.has('contact_posted')) return;

          url.searchParams.delete('contact_posted');
          window.history.replaceState(window.history.state, document.title, url.pathname + url.search + url.hash);
        }

        function parseContactFormResponse(html, responseUrl) {
          var responseDocument = new DOMParser().parseFromString(html, 'text/html');
          var returnedForm = responseDocument.getElementById(form.id);
          var returnedSuccess = returnedForm
            ? returnedForm.querySelector('.js-dcf-success')
            : responseDocument.querySelector('.js-dcf-success');
          var returnedError = returnedForm
            ? returnedForm.querySelector('.js-dcf-error')
            : responseDocument.querySelector('.js-dcf-error');
          var postedByUrl = typeof responseUrl === 'string' && responseUrl.indexOf('contact_posted=true') !== -1;
          var postedByMarkup = returnedSuccess && !returnedSuccess.hasAttribute('hidden');
          var hasErrorMarkup =
            returnedError && !returnedError.hasAttribute('hidden') && returnedError.innerHTML.trim() !== '';

          return {
            postedSuccessfully: postedByUrl || postedByMarkup,
            errorHtml: hasErrorMarkup ? returnedError.innerHTML : '',
          };
        }

        function getFormControls() {
          return form.querySelectorAll('input:not([type="hidden"]):not([type="submit"]), select, textarea');
        }

        function syncControlValidity(control) {
          if (!control || control.disabled || !control.willValidate) return;

          if (control.validity && control.validity.valid) {
            control.removeAttribute('aria-invalid');
          } else {
            control.setAttribute('aria-invalid', 'true');
          }
        }

        function syncAllControlValidity() {
          getFormControls().forEach(function (control) {
            syncControlValidity(control);
          });
        }

        function normalizePhoneControls() {
          var phoneControls = form.querySelectorAll('input[type="tel"]');

          phoneControls.forEach(function (control) {
            var phoneValue = control.value.trim();
            control.setCustomValidity('');

            if (!phoneValue) return;

            var normalizedPhone = normalizeUsPhone(phoneValue);
            if (!normalizedPhone) {
              control.setCustomValidity('Please enter a valid 10-digit US phone number');
              return;
            }

            control.value = normalizedPhone.slice(2);
          });
        }

        getFormControls().forEach(function (control) {
          control.addEventListener('input', function () {
            syncControlValidity(control);
          });
          control.addEventListener('change', function () {
            syncControlValidity(control);
          });
          control.addEventListener('invalid', function () {
            syncControlValidity(control);
          });
        });

        function getFieldValue(fieldName) {
          var controls = form.querySelectorAll('[name="contact[' + fieldName + ']"]');
          var values = [];

          controls.forEach(function (control) {
            if (control.type === 'checkbox' || control.type === 'radio') {
              if (control.checked) {
                values.push(control.value);
              }
            } else {
              values.push(control.value);
            }
          });

          return values.join(',');
        }

        function toggleConditionalField(field) {
          var fieldName = field.dataset.dcfConditionalField;
          var fieldValue = field.dataset.dcfConditionalValue;
          var control = field.querySelector('.js-dcf-conditional-control');
          var isVisible = getFieldValue(fieldName) === fieldValue;

          field.hidden = !isVisible;

          if (control) {
            control.disabled = !isVisible;
            control.required = isVisible && control.dataset.dcfRequired === 'true';
            control.setAttribute('aria-required', control.required ? 'true' : 'false');

            if (!isVisible) {
              control.removeAttribute('aria-invalid');
            }
          }
        }

        conditionalFields.forEach(function (field) {
          var source = form.querySelector('[name="contact[' + field.dataset.dcfConditionalField + ']"]');

          toggleConditionalField(field);

          if (source) {
            source.addEventListener('change', function () {
              toggleConditionalField(field);
            });
          }
        });

        if (!success.hidden) {
          cleanContactPostedQuery();
        }

        if (!isAjaxSubmissionSupported()) return;

        form.addEventListener('submit', function (event) {
          event.preventDefault();
          event.stopPropagation();

          error.hidden = true;
          error.innerHTML = '';

          normalizePhoneControls();

          if (!form.checkValidity()) {
            syncAllControlValidity();
            form.reportValidity();
            return;
          }

          syncAllControlValidity();

          var defaultText = submit.dataset.defaultText || submit.textContent;
          var submittingText = form.dataset.submittingText || defaultText;

          submit.disabled = true;
          submit.textContent = submittingText;
          form.setAttribute('aria-busy', 'true');

          fetch(form.action, {
            method: 'POST',
            body: new FormData(form),
            credentials: 'same-origin',
            headers: {
              Accept: 'text/html,application/xhtml+xml',
              'X-Requested-With': 'XMLHttpRequest',
            },
          })
            .then(function (response) {
              if (!response.ok) {
                throw new Error('Contact form request failed');
              }
              return response.text().then(function (html) {
                return parseContactFormResponse(html, response.url);
              });
            })
            .then(function (result) {
              if (!result.postedSuccessfully) {
                var formError = new Error('Contact form request returned errors');
                formError.errorHtml = result.errorHtml;
                throw formError;
              }

              if (form.dataset.hideFormOnSuccess === 'true') {
                fields.hidden = true;
              }

              cleanContactPostedQuery();
              replaceSuccessTokens();

              if (form.dataset.resetOnSuccess === 'true') {
                form.reset();
              }

              success.hidden = false;
              error.hidden = true;
              success.focus({ preventScroll: true });

              var rect = success.getBoundingClientRect();
              if (rect.top < 0 || rect.bottom > window.innerHeight) {
                success.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }

              return waitForSuccessMessagePaint();
            })
            .then(function () {
              restoreSubmitState(defaultText);
            })
            .catch(function (requestError) {
              if (requestError && requestError.errorHtml) {
                error.innerHTML = requestError.errorHtml;
              } else {
                error.textContent = form.dataset.errorMessage || 'Something went wrong. Please try again.';
              }

              error.hidden = false;
              restoreSubmitState(defaultText);
            });
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initContactForms(document);
      });
    } else {
      initContactForms(document);
    }

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (event) {
        initContactForms(event.target);
      });
      document.addEventListener('shopify:block:select', function (event) {
        initContactForms(event.target);
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["expandable-content"] && !Shopify.designMode) return;
  try {
    (function() {
    function initExpandableContent() {
      var triggers = document.querySelectorAll('.expand-content_trigger');
      triggers.forEach(function(trigger) {
        if (trigger.dataset.initialized) return;
        trigger.dataset.initialized = 'true';

        trigger.addEventListener('click', function() {
          var expanded = this.getAttribute('aria-expanded') === 'true';
          var body = this.nextElementSibling;
          var section = this.closest('.shopify-section');

          if (expanded) {
            this.setAttribute('aria-expanded', 'false');
            body.hidden = true;
          } else {
            if (section) {
              var otherTriggers = section.querySelectorAll('.expand-content_trigger');
              otherTriggers.forEach(function(otherTrigger) {
                if (otherTrigger !== trigger) {
                  otherTrigger.setAttribute('aria-expanded', 'false');
                  otherTrigger.nextElementSibling.hidden = true;
                }
              });
            }
            this.setAttribute('aria-expanded', 'true');
            body.hidden = false;
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initExpandableContent);
    } else {
      initExpandableContent();
    }

    if (Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', initExpandableContent);
      document.addEventListener('shopify:block:select', initExpandableContent);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["klaviyo-list-form"] && !Shopify.designMode) return;
  try {
    (function () {
    function normalizeUsPhone(value) {
      if (window.DieuxAttentiveSms && typeof window.DieuxAttentiveSms.normalizePhone === 'function') {
        return window.DieuxAttentiveSms.normalizePhone(value);
      }

      var phoneValue = String(value || '').trim();
      if (!phoneValue || /[^0-9\s()+.-]/.test(phoneValue)) return '';

      var digits = phoneValue.replace(/\D/g, '');
      if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
      return digits.length === 10 ? '+1' + digits : '';
    }

    function isMarketingAllowed() {
      try {
        if (window.Shopify && window.Shopify.customerPrivacy) {
          if (typeof Shopify.customerPrivacy.marketingAllowed === 'function') {
            return Shopify.customerPrivacy.marketingAllowed();
          }
          if (typeof Shopify.customerPrivacy.currentVisitorConsent === 'function') {
            var c = Shopify.customerPrivacy.currentVisitorConsent();
            if (c && c.marketing !== undefined) {
              return c.marketing === 'yes' || c.marketing === true;
            }
          }
        }
      } catch (e) {}
      return true;
    }

    function KlaviyoListForm() {
      this.forms = [];
      this.init();
    }

    KlaviyoListForm.prototype.init = function () {
      var self = this;
      var wrappers = document.querySelectorAll('.js-klf-wrapper');

      wrappers.forEach(function (wrapper) {
        if (wrapper.classList.contains('klf-initialized')) return;
        wrapper.classList.add('klf-initialized');

        var formData = {
          wrapper: wrapper,
          form: wrapper.querySelector('.js-klf-form'),
          extra: {},
          smsSubmissionPromise: null,
          hasSentFbEvent: false,
        };

        if (!formData.form) return;

        console.log('[Klaviyo List Form] Initializing form:', formData.form.id);
        self.forms.push(formData);
        self.setupUtmParams(formData);
        self.setupForm(formData);
        self.setupPhoneSync(formData);
      });
    };

    KlaviyoListForm.prototype.setupUtmParams = function (formData) {
      var params = new URLSearchParams(window.location.search);
      var utmSource = params.get('utm_source');
      var utmCampaign = params.get('utm_campaign');

      if (utmSource) {
        var sourceInput = formData.form.querySelector('.js-klf-utm-source');
        if (sourceInput) sourceInput.value = utmSource;
        formData.extra.$utm_source = utmSource;
      }

      if (utmCampaign) {
        var campaignInput = formData.form.querySelector('.js-klf-utm-campaign');
        if (campaignInput) campaignInput.value = utmCampaign;
        formData.extra.$utm_campaign = utmCampaign;
      }

      var source = formData.form.dataset.source;
      if (source) {
        formData.extra.$source = source;
      }
    };

    KlaviyoListForm.prototype.setupPhoneSync = function (formData) {
      var form = formData.form;
      var visiblePhoneInput = form.querySelector('.js-phone-input');
      var hiddenPhoneInput = form.querySelector('input[name="phone_number"]');

      if (!visiblePhoneInput || !hiddenPhoneInput) return;

      // Sync on input
      visiblePhoneInput.addEventListener('input', function () {
        if (visiblePhoneInput.itiInstance) {
          hiddenPhoneInput.value = visiblePhoneInput.itiInstance.getNumber();
        }
      });

      // Sync on blur as fallback
      visiblePhoneInput.addEventListener('blur', function () {
        if (visiblePhoneInput.itiInstance) {
          hiddenPhoneInput.value = visiblePhoneInput.itiInstance.getNumber();
        }
        // Manual fallback if iti not available
        if (!hiddenPhoneInput.value && visiblePhoneInput.value) {
          var cleaned = visiblePhoneInput.value.replace(/\D/g, '');
          if (cleaned.length === 10) {
            hiddenPhoneInput.value = '+1' + cleaned;
          } else if (cleaned.length === 11 && cleaned[0] === '1') {
            hiddenPhoneInput.value = '+' + cleaned;
          }
        }
      });
    };

    KlaviyoListForm.prototype.setupForm = function (formData) {
      var self = this;
      var form = formData.form;

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();

        console.log('[Klaviyo List Form] Form submission triggered', form.id);

        if (!self.validateForm(formData)) {
          return false;
        }

        // Sync phone value before submission
        self.syncPhoneValue(formData);

        self.startSmsSubmission(formData).catch(function () {});

        self.submitForm(formData, function (success) {
          console.log('[Klaviyo List Form] Submit callback executed, success:', success);
          if (success) {
            self.showSuccess(formData);
          }
        });

        return false;
      });

      // Handle Enter key
      form.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        var target = e.target;
        if (target.tagName === 'TEXTAREA') return;

        e.preventDefault();
        e.stopPropagation();

        var submitBtn = form.querySelector('.js-klf-submit');
        if (submitBtn) {
          submitBtn.click();
        }
      });
    };

    KlaviyoListForm.prototype.syncPhoneValue = function (formData) {
      var form = formData.form;
      var visiblePhoneInput = form.querySelector('.js-phone-input');
      var hiddenPhoneInput = form.querySelector('input[name="phone_number"]');

      if (!visiblePhoneInput || !hiddenPhoneInput) return;

      var phoneNumber = visiblePhoneInput.value;
      if (visiblePhoneInput.itiInstance) {
        phoneNumber = visiblePhoneInput.itiInstance.getNumber() || phoneNumber;
      }

      hiddenPhoneInput.value = normalizeUsPhone(phoneNumber);
    };

    KlaviyoListForm.prototype.validateForm = function (formData) {
      var form = formData.form;
      var inputs = form.querySelectorAll('input[required], textarea[required], select[required]');
      var isValid = true;

      inputs.forEach(function (input) {
        if (!input.checkValidity()) {
          input.reportValidity();
          isValid = false;
        }
      });

      var emailInput = form.querySelector('input[type="email"]');
      if (emailInput && emailInput.value) {
        var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailPattern.test(emailInput.value)) {
          emailInput.setCustomValidity('Please enter a valid email address');
          emailInput.reportValidity();
          isValid = false;
        } else {
          emailInput.setCustomValidity('');
        }
      }

      var hiddenPhone = form.querySelector('input[name="phone_number"]');
      var visiblePhone = form.querySelector('.js-phone-input');
      if (hiddenPhone && visiblePhone && visiblePhone.value.trim()) {
        var normalizedPhone = normalizeUsPhone(hiddenPhone.value || visiblePhone.value);
        if (!normalizedPhone) {
          visiblePhone.setCustomValidity('Please enter a valid 10-digit US phone number');
          visiblePhone.reportValidity();
          isValid = false;
        } else {
          hiddenPhone.value = normalizedPhone;
          visiblePhone.setCustomValidity('');
        }
      }

      return isValid;
    };

    KlaviyoListForm.prototype.sendFacebookTracking = function (formData) {
      if (formData.hasSentFbEvent) return;

      var form = formData.form;
      var enableTracking = form.dataset.enableFacebookTracking === 'true';
      if (!enableTracking) return;

      var pixelId = form.dataset.facebookPixelId;
      if (!pixelId) return;

      if (!isMarketingAllowed()) return;

      var url = 'https://www.facebook.com/tr?id=' + pixelId + '&ev=Lead&noscript=1';
      url += '&dl=' + encodeURIComponent(document.location.href);
      url += '&cb=' + Date.now();

      var img = document.createElement('img');
      img.src = url;
      img.style.display = 'none';
      document.body.appendChild(img);

      formData.hasSentFbEvent = true;
    };

    KlaviyoListForm.prototype.startSmsSubmission = function (formData) {
      if (formData.smsSubmissionPromise) return formData.smsSubmissionPromise;

      var form = formData.form;
      var hiddenPhoneInput = form.querySelector('input[name="phone_number"]');
      var emailInput = form.querySelector('input[name="email"]');
      var phoneNumber = hiddenPhoneInput ? hiddenPhoneInput.value.trim() : '';
      var signupSourceId = String(form.dataset.attentiveSignupSourceId || '').trim();

      if (!phoneNumber || !signupSourceId) return Promise.resolve({ ok: true, skipped: true });

      if (!window.DieuxAttentiveSms || typeof window.DieuxAttentiveSms.submit !== 'function') {
        return Promise.reject(new Error('Attentive SMS client unavailable'));
      }

      formData.smsSubmissionPromise = window.DieuxAttentiveSms.submit(
        form,
        phoneNumber,
        emailInput ? emailInput.value : ''
      ).catch(function (error) {
        formData.smsSubmissionPromise = null;
        throw error;
      });
      return formData.smsSubmissionPromise;
    };

    KlaviyoListForm.prototype.submitForm = function (formData, callback) {
      var self = this;
      var form = formData.form;

      var emailInput = form.querySelector('input[name="email"]');
      var email = emailInput ? emailInput.value.trim() : null;

      if (!email) {
        self.showError(formData, 'Please enter an email address');
        if (callback) callback(false);
        return;
      }

      var submitData = {
        g: form.querySelector('input[name="g"]').value,
        email: email,
      };

      // Include phone number if present
      var phoneInput = form.querySelector('input[name="phone_number"]');
      if (phoneInput && phoneInput.value) {
        submitData.phone_number = phoneInput.value.trim();
      }

      // Include extra fields
      Object.keys(formData.extra).forEach(function (key) {
        if (key === '$source' || key === '$utm_source' || key === '$utm_campaign') {
          submitData['$fields'] = submitData['$fields'] || '';
          if (submitData['$fields']) submitData['$fields'] += ',';
          submitData['$fields'] += key;
          submitData[key] = formData.extra[key];
        } else {
          var value = formData.extra[key];
          if (value !== '' && value !== null && value !== undefined) {
            submitData['$fields'] = submitData['$fields'] || '';
            if (submitData['$fields']) submitData['$fields'] += ',';
            submitData['$fields'] += key;
            submitData[key] = value;
          }
        }
      });

      // Collect any additional custom fields
      var customFields = form.querySelectorAll('.additional-field-wrapper input[name], .additional-field-wrapper textarea[name], .additional-field-wrapper select[name]');
      customFields.forEach(function (field) {
        var name = field.getAttribute('name');
        var value = field.type === 'checkbox' ? field.checked : field.value.trim();
        if (name && value !== '' && value !== null && value !== undefined && name !== 'email' && name !== 'phone_number' && name !== 'g') {
          submitData['$fields'] = submitData['$fields'] || '';
          if (submitData['$fields']) submitData['$fields'] += ',';
          submitData['$fields'] += name;
          submitData[name] = value;
        }
      });

      var ajaxUrl = form.dataset.ajaxSubmit || '//manage.kmail-lists.com/ajax/subscriptions/subscribe';

      console.log('[Klaviyo List Form] Submitting to:', ajaxUrl);
      console.log('[Klaviyo List Form] Submit data:', submitData);

      var queryString = Object.keys(submitData)
        .map(function (key) {
          return encodeURIComponent(key) + '=' + encodeURIComponent(submitData[key]);
        })
        .join('&');

      var xhr = new XMLHttpRequest();
      xhr.open('POST', ajaxUrl, true);
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          console.log('[Klaviyo List Form] Response status:', xhr.status);
          console.log('[Klaviyo List Form] Response text:', xhr.responseText);
          
          if (xhr.status === 200) {
            try {
              var response = JSON.parse(xhr.responseText);
              console.log('[Klaviyo List Form] Parsed response:', response);
              
              if (response.success || response.data) {
                console.log('[Klaviyo List Form] Submission successful, showing success message');
                if (callback) callback(true);
              } else {
                console.log('[Klaviyo List Form] Submission failed:', response.errors);
                self.showError(formData, response.errors || 'Submission failed');
                if (callback) callback(false);
              }
            } catch (e) {
              console.log('[Klaviyo List Form] Error parsing response:', e);
              if (callback) callback(true);
            }
          } else {
            console.log('[Klaviyo List Form] Network error');
            self.showError(formData, 'Network error. Please try again.');
            if (callback) callback(false);
          }
        }
      };

      xhr.send(queryString);
    };

    KlaviyoListForm.prototype.showSuccess = function (formData) {
      console.log('[Klaviyo List Form] showSuccess called');
      var wrapper = formData.wrapper;

      this.sendFacebookTracking(formData);

      if (window.innerWidth < 1050) {
        var formRect = formData.form.getBoundingClientRect();
        var scrollTo = formRect.top + window.pageYOffset - window.innerHeight / 2 + formRect.height / 2;
        window.scrollTo({ top: scrollTo, behavior: 'smooth' });
      }

      var fieldsEl = wrapper.querySelector('.js-klf-fields');
      var successEl = wrapper.querySelector('.js-klf-success');
      var errorEl = wrapper.querySelector('.js-klf-error');
      var disclaimerEl = wrapper.querySelector('.js-klf-disclaimer');

      console.log('[Klaviyo List Form] Elements found:', {
        fieldsEl: !!fieldsEl,
        successEl: !!successEl,
        errorEl: !!errorEl,
        disclaimerEl: !!disclaimerEl
      });

      if (fieldsEl) fieldsEl.style.display = 'none';
      if (successEl) successEl.style.display = 'block';
      if (errorEl) errorEl.style.display = 'none';
      if (disclaimerEl) disclaimerEl.style.display = 'none';

      // Remove sticky footer if present
      var stickyFooter = document.querySelector('.js-pdp-sticky-footer');
      if (stickyFooter) stickyFooter.remove();
      var stickyFooterLink = document.querySelector('.js-sticky-footer-link');
      if (stickyFooterLink) stickyFooterLink.remove();

      // Execute additional JS on submit if provided
      var additionalJs = formData.form.dataset.additionalJsOnSubmit;
      if (additionalJs) {
        console.log('[Klaviyo List Form] Executing additional JS:', additionalJs);
        try {
          var fn = new Function(additionalJs);
          fn();
          console.log('[Klaviyo List Form] Additional JS executed successfully');
        } catch (e) {
          console.error('[Klaviyo List Form] Error executing additional JS on submit:', e);
        }
      }
    };

    KlaviyoListForm.prototype.showError = function (formData, errorMsg) {
      var wrapper = formData.wrapper;
      var errorEl = wrapper.querySelector('.js-klf-error');

      if (typeof errorMsg === 'object') {
        if (errorMsg.message) {
          errorMsg = errorMsg.message;
        } else if (Array.isArray(errorMsg) && errorMsg.length > 0) {
          errorMsg = errorMsg[0].message || 'Something went wrong. Please try again.';
        } else {
          errorMsg = 'Something went wrong. Please try again.';
        }
      }

      if (errorEl) {
        errorEl.textContent = errorMsg || 'Something went wrong. Please try again.';
        errorEl.style.display = 'block';
      }
    };

    function initKLF() {
      new KlaviyoListForm();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initKLF);
    } else {
      initKLF();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["klaviyo-multi-page-form"] && !Shopify.designMode) return;
  try {
    (function () {
    function normalizeUsPhone(value) {
      if (window.DieuxAttentiveSms && typeof window.DieuxAttentiveSms.normalizePhone === 'function') {
        return window.DieuxAttentiveSms.normalizePhone(value);
      }

      var phoneValue = String(value || '').trim();
      if (!phoneValue || /[^0-9\s()+.-]/.test(phoneValue)) return '';

      var digits = phoneValue.replace(/\D/g, '');
      if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
      return digits.length === 10 ? '+1' + digits : '';
    }

    function isMarketingAllowed() {
      try {
        if (window.Shopify && window.Shopify.customerPrivacy) {
          if (typeof Shopify.customerPrivacy.marketingAllowed === 'function') {
            return Shopify.customerPrivacy.marketingAllowed();
          }
          if (typeof Shopify.customerPrivacy.currentVisitorConsent === 'function') {
            var consent = Shopify.customerPrivacy.currentVisitorConsent();
            if (consent && consent.marketing !== undefined) {
              return consent.marketing === 'yes' || consent.marketing === true;
            }
          }
        }
      } catch (e) {}
      return true;
    }

    function KlaviyoMultiPageForm() {
      this.forms = [];
      this.init();
    }

    KlaviyoMultiPageForm.prototype.init = function () {
      var self = this;
      var wrappers = document.querySelectorAll('.js-mpf-wrapper');

      wrappers.forEach(function (wrapper) {
        if (wrapper.classList.contains('mpf-initialized')) return;
        wrapper.classList.add('mpf-initialized');

        var formData = {
          wrapper: wrapper,
          form: wrapper.querySelector('.js-mpf-form'),
          pages: wrapper.querySelectorAll('.js-mpf-page'),
          currentPage: 0,
          totalPages: 0,
          extra: {},
          collectedEmail: null,
          submittedPages: [],
          smsSubmissionPromise: null,
          hasSentFbEvent: false,
        };

        if (formData.pages.length === 0) return;

        formData.totalPages = formData.pages.length;

        self.forms.push(formData);
        self.setupNavigation(formData);
        self.setupUtmParams(formData);
        self.setupForm(formData);
      });
    };

    KlaviyoMultiPageForm.prototype.setupUtmParams = function (formData) {
      var params = new URLSearchParams(window.location.search);
      var utmSource = params.get('utm_source');
      var utmCampaign = params.get('utm_campaign');

      if (utmSource) {
        var sourceInput = formData.form.querySelector('.js-mpf-utm-source');
        if (sourceInput) sourceInput.value = utmSource;
        formData.extra.$utm_source = utmSource;
      }

      if (utmCampaign) {
        var campaignInput = formData.form.querySelector('.js-mpf-utm-campaign');
        if (campaignInput) campaignInput.value = utmCampaign;
        formData.extra.$utm_campaign = utmCampaign;
      }

      var source = formData.form.dataset.source;
      if (source) {
        formData.extra.$source = source;
      }
    };

    KlaviyoMultiPageForm.prototype.setupNavigation = function (formData) {
      var self = this;
      var pages = formData.pages;
      var totalPages = formData.totalPages;

      formData.form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (!self.validateCurrentPage(formData)) {
          return false;
        }

        self.submitForm(formData, function (success) {
          if (success) {
            self.showSuccess(formData);
          }
        });

        return false;
      });

      formData.form.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;

        var target = e.target;
        if (target.tagName === 'TEXTAREA') return;

        var currentPage = formData.pages[formData.currentPage];
        if (!currentPage) return;

        // Sync phone value before proceeding (Enter key doesn't trigger blur)
        var phoneInput = currentPage.querySelector('input[name="phone_number"]');
        var visiblePhoneInput = currentPage.querySelector('.js-mpf-phone-input');
        if (phoneInput && visiblePhoneInput && visiblePhoneInput.value) {
          // Trigger blur to sync the value
          visiblePhoneInput.blur();
          // Also try manual sync as fallback
          if (!phoneInput.value) {
            if (visiblePhoneInput.itiInstance) {
              phoneInput.value = visiblePhoneInput.itiInstance.getNumber();
            }
            if (!phoneInput.value) {
              var cleaned = visiblePhoneInput.value.replace(/\D/g, '');
              if (cleaned.length === 10) {
                phoneInput.value = '+1' + cleaned;
              } else if (cleaned.length === 11 && cleaned[0] === '1') {
                phoneInput.value = '+' + cleaned;
              }
            }
          }
        }

        var button = currentPage.querySelector('.js-mpf-button');

        if (button) {
          e.preventDefault();
          e.stopPropagation();
          button.click();
        }
      });

      pages.forEach(function (page, index) {
        page.classList.add('mpf-page--ready');
        page.setAttribute('data-page-index', index);

        var button = page.querySelector('.js-mpf-button');
        if (!button) return;

        var isLastPage = index === totalPages - 1;

        if (isLastPage) {
          button.setAttribute('type', 'submit');
          button.setAttribute('data-ga4-click', 'klaviyo-form-submit');
          button.setAttribute(
            'data-ga4-params',
            JSON.stringify({
              CUSTOM_form_id: formData.form.id,
              CUSTOM_list_id: formData.form.querySelector('input[name="g"]').value,
              CUSTOM_signup_source: formData.form.dataset.source || '',
            })
          );
        } else {
          button.setAttribute('type', 'button');
          button.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            self.goToNextPage(formData);
          });
        }

        var skipButton = page.querySelector('.js-mpf-skip');
        if (skipButton) {
          skipButton.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            self.skipToNextPage(formData);
          });
        }
      });
    };

    KlaviyoMultiPageForm.prototype.syncPhoneField = function (page) {
      if (!page) return '';

      var hiddenPhone = page.querySelector('input[name="phone_number"]');
      var visiblePhone = page.querySelector('.js-mpf-phone-input');
      if (!hiddenPhone || !visiblePhone) return '';

      var phoneNumber = visiblePhone.value.trim();
      if (phoneNumber && visiblePhone.itiInstance) {
        phoneNumber = visiblePhone.itiInstance.getNumber() || phoneNumber;
      }

      hiddenPhone.value = normalizeUsPhone(phoneNumber);
      return hiddenPhone.value;
    };

    KlaviyoMultiPageForm.prototype.validateCurrentPage = function (formData) {
      var currentPage = formData.pages[formData.currentPage];
      if (!currentPage) return true; // No page to validate

      var visiblePhone = currentPage.querySelector('.js-mpf-phone-input');
      var normalizedPhone = this.syncPhoneField(currentPage);
      if (visiblePhone) {
        visiblePhone.setCustomValidity('');
      }

      var inputs = currentPage.querySelectorAll('input[required], textarea[required], select[required]');
      var isValid = true;

      inputs.forEach(function (input) {
        if (!input.checkValidity()) {
          input.reportValidity();
          isValid = false;
        }
      });

      var emailInput = currentPage.querySelector('input[type="email"]');
      if (emailInput && emailInput.value) {
        var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailPattern.test(emailInput.value)) {
          emailInput.setCustomValidity('Please enter a valid email address');
          emailInput.reportValidity();
          isValid = false;
        } else {
          emailInput.setCustomValidity('');
        }
      }

      if (visiblePhone && visiblePhone.value.trim() && !normalizedPhone) {
        visiblePhone.setCustomValidity('Please enter a valid 10-digit US phone number');
        visiblePhone.reportValidity();
        isValid = false;
      }

      return isValid;
    };

    KlaviyoMultiPageForm.prototype.submitForm = function (formData, callback) {
      var self = this;
      var form = formData.form;
      var pageIndex = formData.currentPage;

      this.syncPhoneField(formData.pages[pageIndex]);
      this.collectPageFields(formData, pageIndex);
      var smsSubmissionPromise = formData.smsSubmissionPromise || Promise.resolve(true);

      var page = formData.pages[pageIndex];
      if (page) {
        var phoneInput = page.querySelector('input[name="phone_number"]');

        if (phoneInput && phoneInput.value) {
          smsSubmissionPromise = this.startSmsSubmission(formData, phoneInput.value);
        }
      }

      if (!formData.smsSubmissionPromise && formData.extra.phone_number) {
        smsSubmissionPromise = this.startSmsSubmission(formData, formData.extra.phone_number);
      }

      var email = formData.collectedEmail;
      if (!email) {
        if (callback) callback(false, smsSubmissionPromise);
        return;
      }

      var submitData = {
        g: form.querySelector('input[name="g"]').value,
        email: email,
      };

      if (formData.extra.phone_number) {
        submitData.phone_number = formData.extra.phone_number;
      }

      Object.keys(formData.extra).forEach(function (key) {
        if (key === 'phone_number') return;

        if (key === '$source' || key === '$utm_source' || key === '$utm_campaign') {
          submitData['$fields'] = submitData['$fields'] || '';
          if (submitData['$fields']) submitData['$fields'] += ',';
          submitData['$fields'] += key;
          submitData[key] = formData.extra[key];
        } else {
          var value = formData.extra[key];
          if (value !== '' && value !== null && value !== undefined) {
            submitData['$fields'] = submitData['$fields'] || '';
            if (submitData['$fields']) submitData['$fields'] += ',';
            submitData['$fields'] += key;
            submitData[key] = value;
          }
        }
      });

      var ajaxUrl = form.dataset.ajaxSubmit || '//manage.kmail-lists.com/ajax/subscriptions/subscribe';

      var queryString = Object.keys(submitData)
        .map(function (key) {
          return encodeURIComponent(key) + '=' + encodeURIComponent(submitData[key]);
        })
        .join('&');

      var xhr = new XMLHttpRequest();
      xhr.open('POST', ajaxUrl, true);
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            try {
              var response = JSON.parse(xhr.responseText);
              if (response.success || response.data) {
                if (callback) callback(true, smsSubmissionPromise);
              } else {
                self.showError(formData, response.errors || 'Submission failed');
                if (callback) callback(false, smsSubmissionPromise);
              }
            } catch (e) {
              if (callback) callback(true, smsSubmissionPromise);
            }
          } else {
            self.showError(formData, 'Network error. Please try again.');
            if (callback) callback(false, smsSubmissionPromise);
          }
        }
      };

      xhr.send(queryString);
    };

    KlaviyoMultiPageForm.prototype.goToNextPage = function (formData) {
      var self = this;

      if (!this.validateCurrentPage(formData)) return;

      var currentPage = formData.currentPage;
      var totalPages = formData.totalPages;

      if (currentPage < totalPages - 1) {
        var page = formData.pages[currentPage];
        this.syncPhoneField(page);
        this.collectPageFields(formData, currentPage);

        var phoneInput = page.querySelector('input[name="phone_number"]');
        if (phoneInput && phoneInput.value) {
          this.startSmsSubmission(formData, phoneInput.value);
        }

        // Submit collected data to Klaviyo on each page transition
        this.submitPageData(formData, function (success) {
          // Proceed to next page regardless of submission result
          // (we don't want to block the user if there's a network issue)
          var currentPageEl = formData.pages[currentPage];
          var nextPageEl = formData.pages[currentPage + 1];

          if (currentPageEl && nextPageEl) {
            currentPageEl.setAttribute('data-page-index', currentPage);
            currentPageEl.style.display = 'none';
            formData.currentPage++;
            nextPageEl.setAttribute('data-page-index', formData.currentPage);
            nextPageEl.style.display = 'block';

            var wrapper = formData.wrapper;
            if (window.innerWidth < 1050) {
              var rect = wrapper.getBoundingClientRect();
              var scrollTo = rect.top + window.pageYOffset - window.innerHeight / 2 + rect.height / 2;
              window.scrollTo({ top: scrollTo, behavior: 'smooth' });
            }
          }
        });
      }
    };

    KlaviyoMultiPageForm.prototype.submitPageData = function (formData, callback) {
      var self = this;
      var form = formData.form;

      var email = formData.collectedEmail;

      // If no email collected yet, we can't submit to Klaviyo
      if (!email) {
        if (callback) callback(false);
        return;
      }

      var submitData = {
        g: form.querySelector('input[name="g"]').value,
        email: email,
      };

      // Include phone number if collected
      if (formData.extra.phone_number) {
        submitData.phone_number = formData.extra.phone_number;
      }

      // Include all extra fields collected so far
      Object.keys(formData.extra).forEach(function (key) {
        if (key === 'phone_number') return; // Already handled above

        if (key === '$source' || key === '$utm_source' || key === '$utm_campaign') {
          submitData['$fields'] = submitData['$fields'] || '';
          if (submitData['$fields']) submitData['$fields'] += ',';
          submitData['$fields'] += key;
          submitData[key] = formData.extra[key];
        } else {
          var value = formData.extra[key];
          if (value !== '' && value !== null && value !== undefined) {
            submitData['$fields'] = submitData['$fields'] || '';
            if (submitData['$fields']) submitData['$fields'] += ',';
            submitData['$fields'] += key;
            submitData[key] = value;
          }
        }
      });

      var ajaxUrl = form.dataset.ajaxSubmit || '//manage.kmail-lists.com/ajax/subscriptions/subscribe';

      var queryString = Object.keys(submitData)
        .map(function (key) {
          return encodeURIComponent(key) + '=' + encodeURIComponent(submitData[key]);
        })
        .join('&');

      var xhr = new XMLHttpRequest();
      xhr.open('POST', ajaxUrl, true);
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            if (callback) callback(true);
          } else {
            if (callback) callback(false);
          }
        }
      };

      xhr.send(queryString);
    };

    KlaviyoMultiPageForm.prototype.collectPageFields = function (formData, pageIndex) {
      var page = formData.pages[pageIndex];
      if (!page) return;

      var emailInput = page.querySelector('input[type="email"]');
      if (emailInput && emailInput.value) {
        formData.collectedEmail = emailInput.value.trim();
      }

      var phoneInput = page.querySelector('input[name="phone_number"]');
      if (phoneInput) {
        if (phoneInput.value) {
          formData.extra.phone_number = phoneInput.value.trim();
        } else {
          delete formData.extra.phone_number;
        }
      }

      var customFields = page.querySelectorAll('.js-mpf-custom-field');
      customFields.forEach(function (field) {
        var name = field.getAttribute('name');
        var value = field.type === 'checkbox' ? field.checked : field.value.trim();
        if (name && value !== '' && value !== null && value !== undefined) {
          formData.extra[name] = value;
        }
      });

      var textInputs = page.querySelectorAll('input[type="text"][name], textarea[name]');
      textInputs.forEach(function (input) {
        var name = input.getAttribute('name');
        var value = input.value.trim();
        if (name && value && name !== 'email' && name !== 'phone_number') {
          formData.extra[name] = value;
        }
      });
    };

    KlaviyoMultiPageForm.prototype.skipToNextPage = function (formData) {
      var self = this;
      var currentPage = formData.currentPage;
      var totalPages = formData.totalPages;
      var isLastPage = currentPage === totalPages - 1;

      if (isLastPage) {
        this.submitForm(formData, function (success) {
          if (success) {
            self.showSuccess(formData);
          }
        });
      } else {
        formData.pages[currentPage].setAttribute('data-page-index', currentPage);
        formData.pages[currentPage].style.display = 'none';
        formData.currentPage++;
        formData.pages[formData.currentPage].setAttribute('data-page-index', formData.currentPage);
        formData.pages[formData.currentPage].style.display = 'block';

        var wrapper = formData.wrapper;
        if (window.innerWidth < 1050) {
          var rect = wrapper.getBoundingClientRect();
          var scrollTo = rect.top + window.pageYOffset - window.innerHeight / 2 + rect.height / 2;
          window.scrollTo({ top: scrollTo, behavior: 'smooth' });
        }
      }
    };

    KlaviyoMultiPageForm.prototype.startSmsSubmission = function (formData, phoneNumber) {
      if (formData.smsSubmissionPromise) return formData.smsSubmissionPromise;

      var form = formData.form;
      var normalizedPhone = String(phoneNumber || '').trim();
      var signupSourceId = String(form.dataset.attentiveSignupSourceId || '').trim();

      if (!normalizedPhone || !signupSourceId) return Promise.resolve(true);

      if (!window.DieuxAttentiveSms || typeof window.DieuxAttentiveSms.submit !== 'function') {
        return Promise.resolve(false);
      }

      formData.smsSubmissionPromise = window.DieuxAttentiveSms
        .submit(form, normalizedPhone, formData.collectedEmail || '')
        .then(
          function () {
            return true;
          },
          function () {
            formData.smsSubmissionPromise = null;
            return false;
          }
        );

      return formData.smsSubmissionPromise;
    };

    KlaviyoMultiPageForm.prototype.sendFacebookTracking = function (formData) {
      if (formData.hasSentFbEvent) return;

      var form = formData.form;
      if (form.dataset.enableFacebookTracking !== 'true') return;

      var pixelId = form.dataset.facebookPixelId;
      if (!pixelId || !isMarketingAllowed()) return;

      var url = 'https://www.facebook.com/tr?id=' + pixelId + '&ev=Lead&noscript=1';
      url += '&dl=' + encodeURIComponent(document.location.href);
      url += '&cb=' + Date.now();

      var img = document.createElement('img');
      img.src = url;
      img.style.display = 'none';
      document.body.appendChild(img);

      formData.hasSentFbEvent = true;
    };

    KlaviyoMultiPageForm.prototype.showSuccess = function (formData) {
      var wrapper = formData.wrapper;
      var $wrapper = $(wrapper);

      if (window.innerWidth < 1050) {
        var formRect = formData.form.getBoundingClientRect();
        var scrollTo = formRect.top + window.pageYOffset - window.innerHeight / 2 + formRect.height / 2;
        window.scrollTo({ top: scrollTo, behavior: 'smooth' });
      }

      $wrapper.find('.js-mpf-pages').css('display', 'none');
      $wrapper.find('.js-mpf-success').css('display', 'block');
      $wrapper.find('.mpf-disclaimer').css('display', 'none');
      $wrapper.find('.js-mpf-error').css('display', 'none');

      $('.js-pdp-sticky-footer').remove();
      $('.js-sticky-footer-link').remove();

      this.sendFacebookTracking(formData);

      // Execute additional JS on submit if provided
      var additionalJs = formData.form.dataset.additionalJsOnSubmit;
      if (additionalJs) {
        try {
          var fn = new Function(additionalJs);
          fn();
        } catch (e) {
          console.error('[Klaviyo MPF] Error executing additional JS on submit:', e);
        }
      }
    };

    KlaviyoMultiPageForm.prototype.showError = function (formData, errorMsg) {
      var wrapper = formData.wrapper;
      var $wrapper = $(wrapper);
      var $errorEl = $wrapper.find('.js-mpf-error');

      if (typeof errorMsg === 'object') {
        if (errorMsg.message) {
          errorMsg = errorMsg.message;
        } else if (Array.isArray(errorMsg) && errorMsg.length > 0) {
          errorMsg = errorMsg[0].message || 'Something went wrong. Please try again.';
        } else {
          errorMsg = 'Something went wrong. Please try again.';
        }
      }

      $errorEl.text(errorMsg || 'Something went wrong. Please try again.').css('display', 'block');
    };

    KlaviyoMultiPageForm.prototype.setupForm = function (formData) {
      var self = this;
      var form = formData.form;

      var customFields = form.querySelectorAll('.js-mpf-custom-field');
      customFields.forEach(function (field) {
        field.addEventListener('input', function () {
          self.harvestExtraFields(formData);
        });
      });

      this.harvestExtraFields(formData);
    };

    KlaviyoMultiPageForm.prototype.harvestExtraFields = function (formData) {
      var form = formData.form;
      var customFields = form.querySelectorAll('.js-mpf-custom-field');

      Object.keys(formData.extra).forEach(function (key) {
        if (key !== '$source' && key !== '$utm_source' && key !== '$utm_campaign') {
          delete formData.extra[key];
        }
      });

      customFields.forEach(function (field) {
        var name = field.getAttribute('name');
        var value = field.type === 'checkbox' ? field.checked : field.value.trim();

        if (name && value !== '' && value !== null && value !== undefined) {
          formData.extra[name] = value;
        }
      });
    };

    function initMPF() {
      new KlaviyoMultiPageForm();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMPF);
    } else {
      initMPF();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["link-to-popup"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
      // Find all popup triggers that start with 'js-' and end with '-popup-trigger'
      const triggers = document.querySelectorAll('[class*="js-"][class*="-popup-trigger"]');
      
      triggers.forEach(function(trigger) {
        // Get the base class name (e.g. 'js-pdp1' or 'js-blockid')
        const triggerClasses = trigger.className.split(' ');
        const popupTriggerClass = triggerClasses.find(c => c.startsWith('js-') && c.endsWith('-popup-trigger'));
        const baseClass = popupTriggerClass.replace('-popup-trigger', '');
        
        // Find corresponding popup
        const popup = document.querySelector(`.${baseClass}-popup`);
        if (!popup) return;
        
        const closeButtons = popup.querySelectorAll('.js-popup-close');

        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          popup.style.display = 'flex';
          popup.style.opacity = '0';
          setTimeout(() => {
            popup.style.transition = 'opacity 0.3s ease-in-out';
            popup.style.opacity = '1';
          }, 10);
        });

        closeButtons.forEach(function(button) {
          button.addEventListener('click', function(e) {
            e.preventDefault();
            popup.style.display = 'none';
          });
        });
      });
    });
  } catch(e) { console.error(e); }
})();

})();
